import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function profileReducer(state = initialState.profile, action) {
  switch (action.type) {
    case types.UPDATE_PROFILE_SUCCESS:
      return action.profile;
    case types.LOAD_PROFILE:
      return { ...state, ...action.payload };
    case types.ADD_RECIPE_TO_FAVORITES_OPTIMISTIC:
      return { ...state, favorites: [...state.favorites, action.recipeId] };
    case types.REMOVE_RECIPE_FROM_FAVORITES_OPTIMISTIC:
      return {
        ...state,
        favorites: state.favorites.filter(
          (favorite) => favorite != action.recipeId
        ),
      };
    default:
      return state;
  }
}
